import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { book } from '../content/book.js';

const STORAGE_KEY = 'wrathofarequiem.consent';

function loadPixel(id) {
  if (!id || typeof window === 'undefined' || window.fbq) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', id);
  window.fbq('track', 'PageView');
  /* eslint-enable */
}

export function getConsent() {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export default function CookieConsent() {
  const { t } = useTranslation();
  const [choice, setChoice] = useState(() => getConsent());

  useEffect(() => {
    if (choice === 'accepted' && book.metaPixelId) {
      loadPixel(book.metaPixelId);
    }
  }, [choice]);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch {
      /* ignore */
    }
    setChoice('accepted');
  };
  const decline = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'declined');
    } catch {
      /* ignore */
    }
    setChoice('declined');
  };

  const open = choice !== 'accepted' && choice !== 'declined';

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 28, transition: { duration: 0.4 } }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.6 }}
          className="fixed inset-x-3 bottom-3 sm:inset-x-6 sm:bottom-6 z-50"
          role="dialog"
          aria-label={t('cookies.title')}
        >
          <div className="mx-auto max-w-3xl bg-ink-base/95 backdrop-blur-md border border-silver-500/25 shadow-[0_30px_80px_-30px_oklch(0_0_0/0.85)] p-5 sm:p-6 rounded-[2px]">
            <div className="flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-7">
              <div className="flex-1 min-w-0">
                <p className="font-noir italic text-silver-50 text-lg sm:text-xl leading-tight">
                  {t('cookies.title')}
                </p>
                <p className="mt-2 text-silver-300 text-[0.82rem] sm:text-sm leading-relaxed text-pretty">
                  {t('cookies.body')}
                </p>
              </div>
              <div className="flex items-center gap-3 sm:gap-4 shrink-0">
                <button
                  type="button"
                  onClick={decline}
                  className="px-4 py-2 text-silver-400 hover:text-silver-100 text-[0.7rem] uppercase tracking-widest2 transition-colors"
                >
                  {t('cookies.decline')}
                </button>
                <button
                  type="button"
                  onClick={accept}
                  className="px-5 py-2.5 border border-silver-500/45 text-silver-50 hover:text-burgundy-100 hover:border-burgundy-200/60 text-[0.7rem] uppercase tracking-widest2 transition-all duration-300 ease-out-quart"
                >
                  {t('cookies.accept')}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
